function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { Image, Tile } from 'ol/layer';
import { ImageWMS, TileWMS } from 'ol/source';
import React from 'react';
import PropTypes from 'prop-types';
import { ensureMap } from '../../hocs/ensureMap';

/**
 * Web Map Service Interface Standard (WMS) provides a simple HTTP interface for requesting
 * geo-registered map images from one or more distributed geospatial databases.
 * A WMS request defines the geographic layer(s) and area of interest to be processed.
 * The response to the request is one or more geo-registered map images (returned as JPEG, PNG, etc)
 * that can be displayed in a browser application.
 * The interface also supports the ability to specify whether the returned images
 * should be transparent so that layers from multiple servers can be combined or not.
 *
 * @see See [Wikipedia - Web Map Service](https://en.wikipedia.org/wiki/Web_Map_Service) for more information.
 */
export var WmsLayer = /*#__PURE__*/function (_React$Component) {
  function WmsLayer() {
    return _React$Component.apply(this, arguments) || this;
  }
  _inheritsLoose(WmsLayer, _React$Component);
  var _proto = WmsLayer.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.addLayer(this.props);
  };
  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var map = nextProps.map;
    if (nextProps.map === this.props.map && this.uriCompare(this.props.uri, nextProps.uri) && nextProps.layerName === this.props.layerName) {
      return;
    }
    map.removeLayer(map._layers[this.id]);
    delete map._layers[this.id];
    this.addLayer(nextProps);
  };
  _proto.uriCompare = function uriCompare(uri, nextUri) {
    if (Array.isArray(uri) && Array.isArray(nextUri)) {
      return uri.join(',') === nextUri.join(',');
    }
    return uri === nextUri;
  };
  _proto.addLayer = function addLayer(props) {
    var map = props.map,
      layerName = props.layerName,
      version = props.version,
      uri = props.uri,
      singleTile = props.singleTile,
      projCode = props.projCode,
      minZoom = props.minZoom,
      maxZoom = props.maxZoom,
      zIndex = props.zIndex,
      getResolution = props.getResolution,
      onPreRender = props.onPreRender,
      onPostRender = props.onPostRender,
      useBaat = props.useBaat,
      baatToken = props.baatToken,
      wmsLayerParams = props.wmsLayerParams,
      crossOrigin = props.crossOrigin;
    var isUrlArray = Array.isArray(uri);
    if (!map) return;
    if (map._layers && map._layers[this.id]) {
      map._layers[this.id].setVisible(true);
      return;
    }
    var _wmsLayerParams = _extends({}, wmsLayerParams || {}, {
      LAYERS: layerName,
      VERSION: version || '1.3.0'
    });
    if (useBaat && baatToken) {
      _wmsLayerParams.GKT = baatToken;
    }
    map._layers = map._layers || {};
    map._layers[this.id] = singleTile ? new Image({
      minResolution: maxZoom && getResolution(maxZoom),
      maxResolution: minZoom && getResolution(minZoom),
      zIndex: zIndex,
      source: new ImageWMS({
        url: isUrlArray ? uri[0] : uri,
        params: _wmsLayerParams,
        projection: projCode,
        crossOrigin: crossOrigin
      })
    }) : new Tile({
      minResolution: maxZoom && getResolution(maxZoom),
      maxResolution: minZoom && getResolution(minZoom),
      zIndex: zIndex,
      source: new TileWMS({
        url: isUrlArray ? undefined : uri,
        urls: isUrlArray ? uri : undefined,
        params: _wmsLayerParams,
        projection: projCode,
        crossOrigin: crossOrigin
      })
    });
    if (onPreRender) {
      map._layers[this.id].on('prerender', onPreRender);
    }
    if (onPostRender) {
      map._layers[this.id].on('postrender', onPostRender);
    }
    this.mountLayer();
  };
  _proto.mountLayer = function mountLayer() {
    var map = this.props.map;
    if (!map) {
      setTimeout(this.mountLayer.bind(this), 200);
      return;
    }
    map.addLayer(map._layers[this.id]);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    var map = this.props.map;
    map._layers[this.id].setVisible(false);
  };
  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("span", null);
  };
  return _createClass(WmsLayer, [{
    key: "id",
    get: function get() {
      return this.props.id;
    }
  }]);
}(React.Component);
WmsLayer.propTypes = process.env.NODE_ENV !== "production" ? {
  /*
   *
   */
  name: PropTypes.string,
  /*
   *
   */
  uri: PropTypes.any.isRequired,
  /*
   *
   */
  id: PropTypes.string.isRequired,
  /*
   *
   */
  layerName: PropTypes.string.isRequired,
  /*
   *
   */
  version: PropTypes.string,
  /*
   *
   */
  singleTile: PropTypes.bool,
  /*
   *
   */
  useBaat: PropTypes.bool,
  /*
   *
   */
  baatToken: PropTypes.string,
  /*
   *
   */
  projCode: PropTypes.string,
  /*
   *
   */
  map: PropTypes.object,
  /*
   *
   */
  minZoom: PropTypes.number,
  /*
   *
   */
  maxZoom: PropTypes.number,
  /*
   *
   */
  zIndex: PropTypes.number,
  /*
   *
   */
  getResolution: PropTypes.func,
  /*
   *
   */
  onPreRender: PropTypes.func,
  /*
   *
   */
  onPostRender: PropTypes.func,
  /*
   *
   */
  wmsLayerParams: PropTypes.object,
  /**
   * Cross origin attribute for image loading. See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for details.
   */
  crossOrigin: PropTypes.string
} : {};
export default ensureMap(WmsLayer);